import { render, staticRenderFns } from "./ArticleShow.vue?vue&type=template&id=05ea44e1&scoped=true"
import script from "./ArticleShow.vue?vue&type=script&lang=js"
export * from "./ArticleShow.vue?vue&type=script&lang=js"
import style0 from "./ArticleShow.vue?vue&type=style&index=0&id=05ea44e1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ea44e1",
  null
  
)

export default component.exports